import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  cardMain: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    minHeight: 0,
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: '#8B8E93',
    textAlign: 'left',
    marginBottom: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  footer: {
    flexShrink: 0,
    marginTop: 8,
    marginLeft: -15,
    marginRight: -15,
    marginBottom: -15,
    paddingTop: 8,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    borderTop: '1px solid #E8ECF2',
    backgroundColor: '#FAFBFC',
    textAlign: 'center',
  },
  footerText: {
    fontSize: 12,
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    color: '#5F6368',
    lineHeight: 1.45,
    letterSpacing: '0.01em',
    margin: 0,
  },
}));

export const StyledDetailsReportCard = styled(Paper)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 15px;
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  min-height: 0;
  max-height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  box-shadow: 0 2px 10px rgba(17, 24, 39, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    border-color: #003366;
    box-shadow: 0 2px 10px rgba(17, 24, 39, 0.06);
  }
  @media (max-width: 1024px) {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
  }
  @media (max-width: 768px) {
    width: 340px;
    min-width: 340px;
    max-width: 340px;
    align-self: center;
  }
`;
